const custMenu = {
	ZZ: {
		shortName: ['外掛', 'plug-in.', '外挂'],
		name: ['外掛', 'plug-in', '外挂'],
		ico: 'suitcase',
		children: {
		},
	},
};

module.exports = (paidMenu) => {
    return { ...paidMenu, ...custMenu };
};